<template>
  <div>
    <b-modal
      size="lg"
      id="modal-tracking-shipping"
      v-model="showModal"
      hide-footer
      hide-header
      centered
    >
      <div class="f-18 mb-3"><b>รายละเอียดการขนส่ง </b> {{ trackingNo }}</div>
      <div class="w-100 mt-3 bg-white">
        <b-table
          striped
          responsive
          :items="itemsTracking"
          :fields="fieldsTracking"
          show-empty
          empty-text="ไม่พบข้อมูล"
          class="table-list m-0"
        >
          <template v-slot:cell(created_time)="data">
            <span>{{
              new Date(data.item.created_time) | moment($formatDateTime)
            }}</span>
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
  <!-- <ModalLoading ref="modalLoading" :hasClose="false" /> -->
</template>
<script>
export default {
  name: "Modal",
  props: {
    trackingNo: {
      required: false,
      type: String,
    },
    ownFleetShippingName: {
      required: false,
      type: String,
    },
    shippingTypeName: {
      required: false,
      type: String,
    },
    dataList: {
      required: false,
    },
  },
  data() {
    return {
      showModal: false,
      itemsTracking: [],
      fieldsTracking: [
        {
          key: "created_time",
          label: "วันที่ทำรายการ",
          class: "w-100px",
        },
        {
          key: "city_name",
          label: "รายละเอียด",
          class: "w-100px",
        },
        {
          key: "status_name_local",
          label: "สถานะ",
          class: "w-100px",
        },
        {
          key: "note",
          label: "หมายเหตุ",
          class: "w-100px",
        },
      ],
    };
  },
  created: async function() {},
  mounted() {},
  methods: {
    show() {
      // if (this.trackingNo) {
      this.getData();
      // }
    },
    hide() {
      this.showModal = false;
    },
    getData: async function() {
      if (this.trackingNo) {
        let data = await this.$callApi(
          "get",
          `${this.$baseUrl}/api/Transaction/GetTrack/${this.trackingNo}`,
          null,
          this.$headers,
          null
        );

        if (data.result == 1) {
          this.$emit("hideLoading");
          this.showModal = true;
          this.itemsTracking = data.detail.data.journey;
          this.trackingData = data.detail.data;
        }
      } else {
        this.$emit("hideLoading");
        this.showModal = true;
      }
    },
  },
};
</script>
